import React from "react";
import { Controller } from "react-hook-form";
import { Switch } from "@headlessui/react";
import Body from "components/Body";
import { CheckIcon } from "@heroicons/react/outline";

export default function Checkbox({
  name,
  label,
  labelDisplay,
  description,
  errors,
  control,
  required = false,
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Switch.Group as="div">
          <Switch.Label
            className={
              labelDisplay === "invisible"
                ? "sr-only"
                : "inline-block mb-1 font-important font-medium uppercase text-sm"
            }
          >
            {`${label}${required ? " *" : ""}`}
          </Switch.Label>
          <Switch
            checked={value}
            onChange={onChange}
            className="flex items-center gap-4"
          >
            <span className="relative inline-flex h-6 w-6 p-1 transition-colors border border-primary bg-gray-100">
              {value ? (
                <>
                  <CheckIcon className="h-4 w-4 text-primary transition-colors" />
                  <span className="sr-only">Coch&eacute;e</span>
                </>
              ) : (
                <span className="sr-only">Non coch&eacute;e</span>
              )}
            </span>
            <Switch.Description
              as="div"
              className="flex-1 prose text-base text-left"
            >
              {description ? <Body value={description} /> : <p>{label}</p>}
            </Switch.Description>
          </Switch>
          {errors && (
            <p
              role="alert"
              className="block mt-1 text-sm text-red-500 font-semibold"
            >
              {errors.message}
            </p>
          )}
        </Switch.Group>
      )}
      rules={{
        required: required ? "Ce champs est requis." : false,
      }}
    />
  );
}
